<template>
	<v-dialog :model-value="dialog.open" width="600" persistent>
		<v-card color="white">
			<v-card-title class="text-h1 font-weight-bold">
				{{ studioSettings ? "Change" : "Select" }} studio
				<v-spacer></v-spacer>
				<v-btn icon="mdi-close" @click="close" variant="plain"></v-btn>
			</v-card-title>
			<v-card-text class="text-body-2">
				<v-form ref="form" v-model="valid">
					<v-combobox
						v-model="studio"
						variant="outlined"
						density="compact"
						placeholder="Select a studio or type a studio reference"
						:menu-props="{contentClass: 'mr-1'}"
						:items="privateStudios"
						item-title="name" item-value="reference"
						:error-messages="error"
						:rules="[v => !!v || 'This field is required']"
						required
						@update:model-value="error = null">
					</v-combobox>
				</v-form>
			</v-card-text>
			<v-card-actions>
				<v-spacer/>
				<v-btn color="primary" @click="close">Close</v-btn>
				<v-btn
					color="primary" variant="flat" class="ml-2" :disabled="!valid || loading"
					:loading="loading" @click="selectStudio(studio)">
					Continue
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>
<script>

import * as _ from "lodash";

export default {
	name: "SelectStudioDialog",

	props: ["dialog", "options"],

	emits: ["close"],

	data() {
		return {
			studioSettings: this.options.studioSettings,
			parent: this.options.parent,
			studio: null,
			privateStudios: [],
			error: null,
			valid: true,
			loading: false
		}
	},

	mounted() {
		this.loadPrivateStudios();
	},

	methods: {
		loadPrivateStudios() {
			this.$store.dispatch(
					"searchStudioSettings",
					{search: `user_id=${this.$store.getters.getUserID()}`}
				)
			    .then(studios =>
					this.privateStudios = studios.filter(s => s.reference !==
				                                              this.studioSettings?.reference)
				)
			    .catch(() =>
					this.$store.commit(
						"SHOW_NOTIFICATION_WITH_TYPE",
						{message: "An error occurred when trying to load the user's private studios."}
					)
				)
		},

		async selectStudio(studio) {
			if (this.$refs.form.validate()) {
				this.loading = true;

				if (!_.isObject(studio)) {	// studio reference typed by user
					studio = {reference: studio};
				}

				if (!!studio.user_id && studio.user_id !== this.$store.getters.getUserID()) {
					this.error = "This studio belongs to another user, please select another one.";
				}
				else {
					this.formatURL(studio.reference);
					this.$store.dispatch("getStudioSettings").then(() => this.close());
				}
				this.loading = false;
			}
		},

		formatURL(newStudioReference) {
			const existingStudioReference = new URLSearchParams(location.search)?.get("studio");
			const newLocationSearch = existingStudioReference ?
			                          location.search.replace(
										  existingStudioReference,
										  newStudioReference
									  ) :
			                          `?studio=${newStudioReference}`;
			const newURL = location.origin.concat(location.pathname).concat(newLocationSearch);
			history.replaceState(null, "", newURL);
		},

		close() {
			this.$emit("close");
		}
	}
};
</script>

<style lang="scss" scoped>
</style>
